import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import type { ScenarioState } from 'entities/scenario';

import { isMplPreApprovalOfferElement, updateOnlineGroupElements } from '../../lib';
import { selectOnlineGroup } from '../creditSelection.selectors';

export const setMplOffersAlreadySentFromSameBank = (state: ScenarioState) => {
  const onlineGroup = selectOnlineGroup({ scenario: state });

  if (!onlineGroup || !onlineGroup.elements) {
    return;
  }

  const statusByBankId = new Map<string, MPLPreApprovalOffer['apiStatus']>();

  const elements = onlineGroup.elements.map((offer) => {
    if (!isMplPreApprovalOfferElement(offer)) {
      return offer;
    }

    if (offer.apiStatus) {
      statusByBankId.set(offer.organizationNewId, offer.apiStatus);
      return offer;
    }

    if (statusByBankId.has(offer.organizationNewId)) {
      return {
        ...offer,
        isAlreadySentFromSameBank: true,
      };
    }

    return offer;
  });

  updateOnlineGroupElements(state, elements);
};
